import React, { useEffect, useState } from 'react';

// import { useHistory } from "react-router";
import classNames from 'classnames';

import PlusIcon from '../../components/orders-table/orders-bottom/plus-icon.svg';
import { SORT_DIRECTION } from '../../types';
import IconBtn from '../icon-btn/icon-btn';

import HeaderItem from './table-header-item';

import './table.scss';

export type Column<T> = {
  title: string;
  name: string;
  Component?: React.FC<any>;
  headerStyle?: Record<string, any>;
  columnWidth?: string;
  noDivider?: boolean;
  isSortable?: boolean;
  dataGetter: (data: T) => any;
  direction?: SORT_DIRECTION;
  onChangeSorting?: (direction: SORT_DIRECTION) => void;
};

interface IProps {
  loading?: boolean;
  count?: number;
  columns: Column<any>[];
  RowComponent: React.FC<any>;
  onRowClick?: (p: any) => void;
  footer?: boolean;
  onLoadMore?: () => void;
  data?: any[];
  isOperationHistory?: boolean;
  isOrdersChanges?: boolean;
  onLoadMoreText?: string;
}

const LOAD_MORE_BUTTON = 'Загрузить еще операции';

export default function Table({
  loading,
  count = 0,
  columns,
  RowComponent,
  onRowClick,
  footer,
  onLoadMore,
  data,
  isOperationHistory,
  isOrdersChanges,
  onLoadMoreText,
}: IProps) {
  const [dataInfo, setData] = useState<any>(new Array(count).fill({}));

  useEffect(() => setData(data), [data]);

  return (
    <div
      className={classNames('table', {
        'table--empty': !dataInfo?.length,
      })}
    >
      {(dataInfo?.length || loading) && (
        <>
          <ul className="table__header">
            {columns.map((column, key) => {
              const {
                headerStyle = {},
                title,
                isSortable,
                name,
                noDivider,
                onChangeSorting,
                direction,
              } = column;
              return (
                <li
                  key={name + key}
                  className={classNames('table__header-item', {
                    'table__header-item_no-divider': !!noDivider,
                  })}
                  style={{ ...headerStyle }}
                >
                  <HeaderItem
                    title={title}
                    isSortable={isSortable}
                    onChangeSorting={onChangeSorting}
                    direction={direction}
                  />
                </li>
              );
            })}
          </ul>
          {dataInfo && Array.isArray(dataInfo) && (
            <div className="table__body">
              {dataInfo.map((elem, index) => (
                <RowComponent
                  loading={loading}
                  rowData={elem}
                  columns={columns}
                  key={`row-component-${index}`}
                  onRowClick={onRowClick}
                />
              ))}
            </div>
          )}
          {footer && (
            <div className="table__footer">
              <IconBtn
                icon={PlusIcon}
                title={onLoadMoreText || LOAD_MORE_BUTTON}
                className="btn--sm btn--outline"
                onClick={onLoadMore}
              />
            </div>
          )}
        </>
      )}
      {!loading && !dataInfo?.length && (
        <div className="table__empty">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path
              d="M58.6668 32H42.6668L37.3335 40H26.6668L21.3335 32H5.3335"
              stroke="#444444"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5335 13.6266L5.3335 32V48C5.3335 49.4144 5.8954 50.771 6.89559 51.7712C7.89579 52.7714 9.25234 53.3333 10.6668 53.3333H53.3335C54.748 53.3333 56.1045 52.7714 57.1047 51.7712C58.1049 50.771 58.6668 49.4144 58.6668 48V32L49.4668 13.6266C49.0253 12.7381 48.3446 11.9903 47.5014 11.4674C46.6581 10.9445 45.6857 10.6672 44.6935 10.6666H19.3068C18.3146 10.6672 17.3422 10.9445 16.4989 11.4674C15.6557 11.9903 14.975 12.7381 14.5335 13.6266V13.6266Z"
              stroke="#444444"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {isOperationHistory && 'У вас еще не было операций'}
          {isOrdersChanges && (
            <>
              Вы пока не создавали и не получали финансовых требований
              {/* <IconBtn
                icon={PlusIcon}
                className="btn--sm btn--outline"
                title="Перейти в реестр"
                onClick={() => history.push("/")}
              /> */}
            </>
          )}
          {!isOperationHistory && !isOrdersChanges && 'Данных пока нет'}
        </div>
      )}
    </div>
  );
}
